export const newHeader = {
  "Como você está se sentindo?": "How are you feeling?",
  "Enviar": "Submit",
  "Se sentindo muito feliz 😆": "Feeling very happy 😆",
  "Se sentindo feliz 🙂": "Feeling happy 🙂",
  "Se sentindo neutro 😐": "Feeling neutral 😐",
  "Se sentindo triste 🙁": "Feeling sad 🙁",
  "Se sentindo muito triste 😓": "Feeling very sad 😓",
  "Sentimento enviado.": "Feeling submitted.",
  "Nos conte porque você está se sentindo assim...": "Tell us why you are feeling this way...",
  "Minha Equipe": "My Team",
  "Sem registro": "No record",
  "Deseja voltar da pausa:": "Do you want to return from the break:",
  "Tempo total em pausa:": "Total time on break:",
  "Selecione o motivo da pausa": "Select the reason for the break",
  "Marcar Ponto": "Clock In/Out",
  "Marcar Pausa": "Start Break",
  "Em Pausa": "On Break",
  "Voltar da pausa": "Return from break",
  "Cancelar": "Cancel",
  "Confirmar pausa": "Confirm break",
  "Marcar pausa": "Start break",
  "Início": "Home",
  "Lembretes": "Reminders",
  "Gestão de tarefas": "Task Management",
  "Comunicados": "Statements",
  "Documentos": "Documents",
  "Feedbacks": "Feedbacks",
  "Reuniões 1:1": "1:1 Meetings",
  "Reembolsos": "Reimbursements",
  "Saldo de horas": "Hour Balance",
  "Solicitações de ajuste": "Adjustment Requests",
  "Férias/Afastamento": "Vacation/Leave",
  "Histórico de Ponto": "Time Clock History",
  "Espelhos de Ponto": "Time Clock Records",
  "Log de Registros": "Record Log",
  "Modo ponto": "Time clock mode",
  "Minha equipe": "My team",
  "Gestão de Ponto": "Timesheet",
  "Gerenciar afastamentos": "Manage absences",
  "Solicitações da equipe": "Team requests",
  "Sobreaviso": "On-call",
  "Modo escuro": "Dark mode",
  "Modo claro": "Light mode",
  "Meu perfil": "My profile",
  "Ouvidoria": "Whistleblowing",
  "Sair": "Log out"
};


// WEBPACK FOOTER //
// ./src/resources/enUS/newHeader.js